import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosCustomersReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/posCustomersReport";

  ur3 = environment.serverAPI5 + "/api/customerPaymentsReport";

  ur2 = environment.serverAPI5 + "/api/customerSalesReport";


  searchPosCustomersReport(query: string, page: number, size: number, sort: string, additionalQuery: any, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "additionalQuery": additionalQuery,
      "groupBy": groupBy
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  searchCustomerPaymentsReport(customerId: number, query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur3}/condition/${customerId}${queryParams}`, requestBody);
  }

  searchcustomerSalesReport(customerId: number, warehouseId: number, query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur2}/condition/${customerId}/${warehouseId}${queryParams}`, requestBody);
  }

  downloadPosCustomersReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getPosCustomersReport(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
